import { createFileRoute, redirect } from '@tanstack/react-router';
import { OtpScreen } from '@/features/auth/OtpScreen.tsx';
import { ensureMe } from '@/features/auth/useMe.ts';

export const Route = createFileRoute('/auth/otp')({
  validateSearch: (s: Record<string, unknown>): { challenge: string; phone: string; resend: number; expires: number; dev?: string; redirect?: string } => ({
    challenge: String(s.challenge ?? ''),
    phone: String(s.phone ?? ''),
    resend: Number(s.resend ?? 60),
    expires: Number(s.expires ?? 120),
    ...(typeof s.dev === 'string' && s.dev ? { dev: s.dev } : {}),
    ...(typeof s.redirect === 'string' ? { redirect: s.redirect } : {}),
  }),
  beforeLoad: async ({ search }) => {
    if (await ensureMe()) throw redirect({ to: '/', replace: true });
    if (!search.challenge) throw redirect({ to: '/auth/phone', search: {} });
  },
  component: OtpRoute,
});

function OtpRoute() {
  const s = Route.useSearch();
  return <OtpScreen challenge={s.challenge} phone={s.phone} resend={s.resend} expires={s.expires} redirect={s.redirect} devCode={s.dev} />;
}
